export enum RoutesConfig {
  DO_IT = 'todo-app',
  HOME = '/',
  USER = 'user/',
  USER_DETAILS = 'account-details',
  USER_LOGIN = 'log-in',
  USER_REGISTER = 'register',
}
